import { useCallback, useEffect, useMemo, useState } from 'react';

import {
  isNotificationDismissed,
  setNotificationDismissed,
  setNotificationRead,
} from 'components/Pages/GuestPortal/LandingLayout/functions';

import { IUseNotificationCenterParams, IHeaderNotification } from './types';

export function useNotificationCenter({ notifications }: IUseNotificationCenterParams) {
  const notificationToShow = useMemo(() => getNotificationStrategy(notifications), [notifications]);
  const showInit = !notificationToShow.isRead;
  const [showPopup, setShowPopup] = useState(false);
  const [showBadge, setShowBadge] = useState(showInit);

  const handleToggleShowPopup = useCallback(
    (needToSetNotificationRead = true) => {
      setShowPopup(!showPopup);
      if (needToSetNotificationRead) {
        setShowBadge(false);
        setNotificationRead(notificationToShow);
      }

      setNotificationDismissed(notificationToShow);
    },
    [showPopup, notificationToShow],
  );

  useEffect(() => {
    if (showInit && !isNotificationDismissed(notificationToShow)) {
      setTimeout(() => {
        setShowPopup(true);
      }, 2000);
    }
  }, []);

  return {
    showPopup,
    showBadge,
    handleToggleShowPopup,
    notificationToShow,
  };
}

function getNotificationStrategy(notifications: IHeaderNotification[]) {
  return notifications.find((n) => !n.read) || notifications[notifications.length - 1];
}
